import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type UpsertAutoApplicationSetting = components['schemas']['UpsertAutoApplicationSetting'];
export type FullExecutorAutoApplicationSetting = components['schemas']['FullExecutorAutoApplicationSetting'];
export type ExecutorAutoApplicationSettings = components['schemas']['ExecutorAutoApplicationSettings'];

type ListOperation = paths['/executor_web/executor_auto_application_settings']['get'];
type GetOperation = paths['/executor_web/executor_auto_application_settings/{id}']['get'];
type CreateOperation = paths['/executor_web/executor_auto_application_settings']['post'];
type UpdateOperation = paths['/executor_web/executor_auto_application_settings/{id}']['put'];

export type FetchAutoApplicationSettingsQuery = NonNullable<ListOperation['parameters']['query']>;
export type FetchAutoApplicationSettingsResponse =
	ListOperation['responses'][200]['content']['application/json'];

export type FetchAutoApplicationSettingResponse =
	GetOperation['responses'][200]['content']['application/json'];

export type CreateAutoApplicationSettingRequest = NonNullable<
	NonNullable<CreateOperation['requestBody']>['content']['application/json']
>;
export type CreateAutoApplicationSettingResponse =
	CreateOperation['responses'][200]['content']['application/json'];

export type UpdateAutoApplicationSettingRequest = NonNullable<
	NonNullable<UpdateOperation['requestBody']>['content']['application/json']
>;
export type UpdateAutoApplicationSettingResponse =
	UpdateOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/executor_auto_application_settings` */
export function fetchAutoApplicationSettings(query?: FetchAutoApplicationSettingsQuery, signal?: AbortSignal) {
	return axiosInstance.get<FetchAutoApplicationSettingsResponse>('executor_auto_application_settings', {
		params: query,
		signal,
	});
}

/** GET `/executor_web/executor_auto_application_settings/{id}` */
export function fetchAutoApplicationSetting(id: number, signal?: AbortSignal) {
	return axiosInstance.get<FetchAutoApplicationSettingResponse>(`executor_auto_application_settings/${id}`, {
		signal,
	});
}

/** POST `/executor_web/executor_auto_application_settings` */
export function createAutoApplicationSetting(body: CreateAutoApplicationSettingRequest, signal?: AbortSignal) {
	return axiosInstance.post<CreateAutoApplicationSettingResponse>(
		'executor_auto_application_settings',
		body,
		{signal},
	);
}

/** PUT `/executor_web/executor_auto_application_settings/{id}` */
export function updateAutoApplicationSetting(
	id: number,
	body: UpdateAutoApplicationSettingRequest,
	signal?: AbortSignal,
) {
	return axiosInstance.put<UpdateAutoApplicationSettingResponse>(
		`executor_auto_application_settings/${id}`,
		body,
		{signal},
	);
}
